"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = require("@atlaskit/form")
    .Field;
